import React from 'react';

const PlansIframeList = ({ iframeUrl }) => {  

  return (""
    
      // <iframe  title="Power BI Report"  src={iframeUrl} style={{width:'100%', height: '600px',height: 'calc(100vh - 160px)'}}  sandbox="allow-scripts allow-same-origin allow-forms allow-popups" allowFullScreen></iframe>
    
  );
}

export default  PlansIframeList;